import { RecipeType } from "@/types/baseTypes";
import { customSanitize } from "@/utils/customSanitize";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";

function RecipeTipps({ recipeDetails }: { recipeDetails: RecipeType }) {
  const { rezept_tipp, rezept_vegitipp } = recipeDetails;
  const { getLabel } = useGlobalContext();
  return (
    <div>
      <h3 className="has-text-centered">{getLabel("tipps")}</h3>
      <div
        dangerouslySetInnerHTML={{ __html: customSanitize(rezept_tipp) }}
      ></div>
      <h3 className="has-text-centered">
        {getLabel("vegitipps", "Vegitipps")}
      </h3>
      <div
        dangerouslySetInnerHTML={{ __html: customSanitize(rezept_vegitipp) }}
      ></div>
    </div>
  );
}

export default RecipeTipps;
